import { i18n } from '@localization'
import { SH3, Stack, YStack } from '@zet/design-system'
import ZindagiSet from '@zet/svg/zetPartner.svg'

const Footer = ({ marginTop = true }) => {
  return (
    <Stack className="items-center py-3">
      <YStack className={`${marginTop ? 'mt-5' : ''} items-center`}>
        <ZindagiSet />
      </YStack>
      <SH3 className="text-grays-60 text-center">
        {i18n.t('brandBenifits.bringingFinancialProductsForBharat')}
      </SH3>
    </Stack>
  )
}
export default Footer
